// Maps a role key to a short "Anagha's <relation>" label in TE/EN.
// Used on the Reveal page (arrival card) and the Dance Floor (projector
// arrival proclamation + TTS) so the royal greeting can name the guest's
// bond with Princess Anagha.

const REL = {
  father:        { te: "అనఘకు ప్రియమైన నాన్న",              en: "Anagha's beloved Father" },
  mother:        { te: "అనఘకు ప్రియమైన అమ్మ",               en: "Anagha's beloved Mother" },
  grandfather:   { te: "అనఘకు ప్రియమైన తాతయ్య",            en: "Anagha's beloved Grandfather" },
  grandmother:   { te: "అనఘకు ప్రియమైన అమ్మమ్మ",            en: "Anagha's beloved Grandmother" },
  peddananna:    { te: "అనఘకు ప్రియమైన పెద్దనాన్న",           en: "Anagha's dear Peddananna" },
  peddamma:      { te: "అనఘకు ప్రియమైన పెద్దమ్మ",             en: "Anagha's dear Peddamma" },
  chinnanna:     { te: "అనఘకు ప్రియమైన చిన్నాన్న / బాబాయి",   en: "Anagha's dear Chinnanna / Babai" },
  pinni:         { te: "అనఘకు ప్రియమైన పిన్ని",              en: "Anagha's dear Pinni" },
  attha:         { te: "అనఘకు ప్రియమైన అత్త",                en: "Anagha's dear Attha" },
  mamayya:       { te: "అనఘకు ప్రియమైన మామయ్య",             en: "Anagha's dear Mamayya" },
  friend_male:   { te: "అనఘకు ప్రియమైన కుటుంబ స్నేహితుడు",   en: "Anagha's dear Family Friend" },
  friend_female: { te: "అనఘకు ప్రియమైన కుటుంబ స్నేహితురాలు", en: "Anagha's dear Family Friend" },
};

const FALLBACK = { te: "అనఘకు ప్రియమైన అతిథి", en: "Anagha's beloved Guest" };

export const relationLabel = (roleKey, lang) => {
  const r = REL[roleKey] || FALLBACK;
  return lang === "en" ? r.en : r.te;
};

// A shorter form for compact chips ("Anagha's Grandfather")
const SHORT = {
  father:        { te: "నాన్న",                    en: "Father" },
  mother:        { te: "అమ్మ",                     en: "Mother" },
  grandfather:   { te: "తాతయ్య",                   en: "Grandfather" },
  grandmother:   { te: "అమ్మమ్మ",                   en: "Grandmother" },
  peddananna:    { te: "పెద్దనాన్న",                 en: "Peddananna" },
  peddamma:      { te: "పెద్దమ్మ",                   en: "Peddamma" },
  chinnanna:     { te: "చిన్నాన్న / బాబాయి",         en: "Chinnanna / Babai" },
  pinni:         { te: "పిన్ని",                    en: "Pinni" },
  attha:         { te: "అత్త",                      en: "Attha" },
  mamayya:       { te: "మామయ్య",                    en: "Mamayya" },
  friend_male:   { te: "కుటుంబ స్నేహితుడు",         en: "Family Friend" },
  friend_female: { te: "కుటుంబ స్నేహితురాలు",       en: "Family Friend" },
};

export const relationShort = (roleKey, lang) => {
  const r = SHORT[roleKey] || { te: "అతిథి", en: "Guest" };
  return lang === "en" ? r.en : r.te;
};
